<template>
  <div class="examination-deatils">
    <canvas id="myCanvas" v-show="false" width="343" height="200"></canvas>
    <div class="content" v-show="!dialogVisible">
      <div class="video-views" :class="{ adjustment: adjustment }">
        <div class="video-sroll" :class="{ 'video-border': adjustment }">
          <div
            style="
              font-weight: bold;
              font-size: 16px;
              line-height: 50px;
              text-align: center;
            "
            v-if="adjustment"
          >
            为了保证你您的考试顺利，请认真完成下列各项设备调试
          </div>
          <div class="video-box" :class="{ 'videx-box-width': !adjustment }">
            <div class="video-view">
              <video
                style="width: 90%"
                id="localVideo"
                autoplay="autoplay"
                muted="true"
              ></video>
            </div>
            <!-- 摄像头选择器已移至视频区域外部 -->
          </div>
          <div class="viedo-tips" v-if="adjustment">
            <p>未检测到/出现异常请查看下方步骤！</p>
            <p>
              1.推荐使用Chrome谷歌浏览器、Firefox火狐浏览器；如果使用360浏览器等国产浏览器，请使用极速模式。
            </p>
            <p>2.请关闭你电脑的杀毒软件，并刷新页面</p>
            <p>3.是否在地址栏左侧允许了摄像头/麦克风的授权？</p>
            <img
              style="width: 100%"
              src="../../../assets/imgs/tips_01.png"
              alt=""
            />
            <img
              style="width: 100%"
              src="../../../assets/imgs/tips_02.png"
              alt=""
            />
          </div>
          <div class="device-select-bar" v-if="adjustment">
            <div>摄像头：</div>
            <el-select v-model="filteredValue" placeholder="请选择摄像头" size="mini" @change="selectGetUserMediaPlay" :popper-append-to-body="true" filterable class="device-select">
              <el-option v-for="(item, index) in filtered" :key="index" :label="item && item.label ? item.label : `默认${index + 1}`" :value="index"></el-option>
            </el-select>
          </div>
          <div style="clear: both; text-align: center" v-if="adjustment">
            <div class="gradient-background btn" @click="isVerifyFace(2)">
              确认
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ 优化：标题栏样式优化，问卷页面时显示"职业健康调查问卷 - 考试名称" -->
      <div class="exam-header" v-if="!adjustment">
        <div class="header-back-btn" @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="header-title" v-if="!showQuestionnaire">
          <el-tooltip :content="itemData && itemData.title" placement="bottom" :disabled="!itemData || !itemData.title || itemData.title.length <= 20" effect="dark">
            <span class="title-text">{{ itemData && itemData.title }}</span>
          </el-tooltip>
        </div>
        <div class="header-title questionnaire-title" v-else>
          <span class="title-label">职业健康调查问卷</span>
          <span class="title-separator">-</span>
          <el-tooltip :content="itemData && itemData.title" placement="bottom" :disabled="!itemData || !itemData.title || itemData.title.length <= 20" effect="dark">
            <span class="title-text">{{ itemData && itemData.title }}</span>
          </el-tooltip>
        </div>
      </div>
      <!-- 问卷填写页面 -->
      <Questionnaire
        v-if="showQuestionnaire"
        :exam-id="Number(examinationId)"
        :template-code="questionnaireTemplateCode"
        @submit-success="handleQuestionnaireSubmit"
        @go-back="handleQuestionnaireGoBack"
        ref="questionnaireRef"
      />
      
      <el-card class="box-card" v-if="examination && !adjustment && !showQuestionnaire">
        <div class="card">
          <div class="question-progress">
            题目 {{ examination.index + 1 }}/{{ examination.total }}
          </div>
          <div>
            【{{
              examination.subject.type == "SC"
                ? "单选题"
                : examination.subject.type == "MC"
                ? "多选题"
                : examination.subject.type == "TF"
                ? "判断题"
                : "简答题"
            }}】
          </div>
          <p>{{ examination.index + 1 }}. {{ examination.subject.title }}</p>
          <el-radio-group
            v-model="examination.value"
            v-if="examination.subject.type == 'SC'"
          >
            <el-radio
              v-for="(opt, _opt) in examination.subject.options"
              :key="_opt"
              :label="opt.index"
              >{{ String.fromCharCode(65 + _opt) }}. {{ opt.title }}</el-radio
            >
          </el-radio-group>
          <el-checkbox-group
            v-model="examination.value"
            v-if="examination.subject.type == 'MC'"
          >
            <el-checkbox
              v-for="(opt, _opt) in examination.subject.options"
              :key="_opt"
              :label="opt.index"
              >{{ String.fromCharCode(65 + _opt) }}. {{ opt.title }}</el-checkbox
            >
          </el-checkbox-group>
          <el-radio-group
            v-model="examination.value"
            v-if="examination.subject.type == 'TF'"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-input
            v-if="examination.subject.type == 'QA'"
            type="textarea"
            :rows="10"
            placeholder="请在该区域内作答"
            v-model="examination.value"
          >
          </el-input>
        </div>
        <div
          class="gradient-background next"
          :class="{ disabled: !hasAnswer }"
          @click="submit"
          v-loading="submitIng"
        >
          {{ examination.total != examination.index + 1 ? "下一题" : "提交" }}
        </div>
      </el-card>
      <el-card class="tips-card" v-if="!adjustment && !showQuestionnaire">
        <p>剩余时间</p>
        <p class="timing">{{ timer }}</p>
        <!-- <p>时间截止到</p>
        <p class="timing">{{ endTime }}</p> -->
        <el-divider></el-divider>
        <p>当前进度</p>
        <p>
          {{ examination && examination.index + 1 }}/{{
            examination && examination.total
          }}
        </p>
      </el-card>
    </div>
    <el-dialog
      v-model="dialogVisible"
      :modal="status > 2"
      :show-close="false"
      :top="status == 1 ? '30vh' : '15vh'"
    >
      <div class="loading" v-if="status == 1">
        {{ tips }}
        <div v-if="erroring">
          <el-button @click="closeWindow">关闭此窗口</el-button>
        </div>
      </div>
      <div class="tips" v-if="status == 2">
        <div class="title">
          {{ itemData.title }}
        </div>
        <div class="time">考试时间长：{{ itemData.times }}分钟</div>
        <div
          class="description"
          v-if="itemData.description && itemData.description != 'null'"
        >
          （{{ itemData.description }}）
        </div>
        <div class="rule">
          <p>考试规则</p>
          <p style="color: red; font-size: 16px">
            考试答题期间不可返回上一题作答，请知悉。
          </p>
          <p>
            1）考生须使用配备摄像头的台式电脑或笔记本电脑进行考试，不支持使用手机、IPAD等移动设备作答。
          </p>
          <p>
            2）请考生使用最新版Chrome浏览器、360极速浏览器或火狐浏览器登录考试答题系统（在线考试平台兼容Windows和Mac
            OS系统）。
          </p>
          <p>
            3）考生须在密闭、独立的空间中完成作答，空间内不得有其他人或声音进行干扰。考试过程中严禁与其他人员交谈。
          </p>
          <p>
            4）考生在考试过程中须确保电脑以及摄像头与考试相关的硬件设备都处于正常工作状态。考试全程须确保摄像头设备录制到本人上半身，考生需确保考试环境的采光良好。
          </p>
          <p>
            5）考试过程中禁止考生对考试内容进行拍照、截屏、录屏或抄写。如有考生将试题泄露或传播，考试主办方将依法追究该考生责任并通报至该考生所属单位严肃处理。
          </p>
          <p>6）其他应当视为违反考试规则的行为，以考试主办方认定为准。</p>
        </div>
        <div class="confirms">
          <div
            class="gradient-background btn"
            @click="loginForm ? confirm() : isVerifyFace(1)"
          >
            {{ loginForm ? "下一步" : "确认" }}
          </div>
        </div>
      </div>
      <div class="submit-tips" v-if="status == 3">
        <p>是否现在交卷？</p>
        <p>交卷后无法再对答案进行修改</p>
        <div class="gradient-border btn" @click="dialogVisible = false">
          取消
        </div>
        <div class="gradient-background btn" @click="confirmSubmit">确认</div>
      </div>
      <div class="submit-loading" v-if="status == 4">
        <p>交卷中</p>
        <el-progress
          :text-inside="true"
          :stroke-width="26"
          :percentage="70"
        ></el-progress>
        <p style="font-size: 12px">正在提交答案，请不要关闭窗口</p>
      </div>
    </el-dialog>
    <DrawerTracking
      @onBack="hideDrawerTracking"
      @success="successTracking"
      :drawer="isTracking"
      :mediaConstraints="mediaConstraints"
    />
  </div>
</template>
<script>
import Peer from "peerjs";
import { domainName } from "../../../assets/js/storage";
import DrawerTracking from "../../../components/DrawerTracking";
import Questionnaire from "./Questionnaire.vue";
import moment from "moment";
import { getTokenRemainingTime, isTokenExpiringSoon } from "../../../utils/jwt";
let _timer;
export default {
  name: "examinationDeatils",
  components: {
    DrawerTracking,
    Questionnaire
  },
  data() {
    return {
      isTracking: false, // 是否打开人脸核身
      trackingType: 1, // 人脸核身类型
      isAdoptTracking: false, // 是否通过人脸核身
      erroring: false,
      itemData: "",
      status: 1,
      dialogVisible: false,
      timer: "00:00",
      totalTime: "3600",
      currentTime: "00:59:59",
      endTime: "",
      examination: null,
      adjustment: false,
      loginForm: null,
      isDone: false,
      isInit: false,
      tips: "正在进入考试......",
      // socket 类型
      type: {
        sendMessageEx: "send::message::one",
        sendGroup: "send::message::group",
        offer: "offer",
        answer: "answer",
        candidate: "candidate",
        cmd: "cmd",
        heart: "heart",
      },
      websocket: null,
      hasSubmit: false,
      mediaConstraints: {
        video: true,
        audio: true,
      },
      countdownTimer: null,
      heartbeatTimer: null,
      heartbeatInterval: 30000,
      lastTokenWarningTime: 0, // 上次token警告时间，用于防抖（仅控制台日志）
      tokenWarningInterval: 300000, // token警告间隔：5分钟（避免控制台日志过多）
      lastWarningMessage: "", // 上次警告消息内容
      lastWarningTime: 0, // 上次警告时间
      warningInterval: 60000, // 警告弹窗间隔：60秒（避免重复弹出相同警告）
      isWarningDialogShowing: false, // 标记是否有警告弹窗正在显示
      configuration: {
        iceServers: [
          {
            urls: "stun:meeting.gdcoh.com:3478",
          },
          {
            urls: "turn:meeting.gdcoh.com:3478",
            username: "kurento",
            credential: "kurento",
          },
        ],
      },
      screenConstraints: {
        video: {
          cursor: "always" | "motion" | "never",
          displaySurface: "application" | "browser" | "monitor" | "window",
        },
      },
      offerOptions: {
        iceRestart: true,
        offerToReceiveAudio: false,
        offerToReceiveVideo: true,
      },
      localMediaStream: null,
      localScreenStream: null,
      rtcPeerConnection: null,
      cmdUser: null,
      setTimes: 20000,
      uploadTimer: null,
      filteredValue: 0, // 保存当前电脑可用摄像头列表
      filtered: [], // 保存当前电脑可用摄像头列表
      isAudioOK: false, //音频是否正常
      submitIng: false,
      // 重试配置常量
      MAX_RETRY_COUNT: 3, // 最大重试次数
      RETRY_DELAY: 1000, // 重试延迟（毫秒）
      // 图片上传降级相关
      uploadFailCount: 0, // 连续上传失败次数
      isUploadDegraded: false, // 是否已降级
      // 序号错误重试相关
      submitRetryCount: 0, // 当前题目重试次数
      currentSubjectIndex: -1, // 当前题目索引
      // 多监考员相关
      activeCalls: new Map(), // 存储所有活跃的监考员连接
      maxInvigilators: 3, // 最多允许3个监考员同时监控
      // Peer重连相关
      peerReconnectAttempts: 0, // Peer重连尝试次数
      maxPeerReconnectAttempts: 5, // 最大重连次数
      peerReconnectDelay: 5000, // 重连延迟（递增）
      monitoringDegraded: false, // 监控是否已降级（仅记录日志）
      monitoringLogPrefix: "[实时监控]",
      currentSessionId: null, // 当前会话ID
      sessionHeartbeatEnabled: false, // 是否启用会话心跳
      // 问卷相关
      showQuestionnaire: false, // 是否显示问卷页面
      questionnaireTemplateCode: null, // 问卷模板代码
      examinationId: null, // 考试ID（用于问卷）
    };
  },
  computed: {
    hasAnswer() {
      const val = this.examination?.value;
      if (val === null || val === undefined) return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "string") return val.trim().length > 0;
      return true; // boolean or number
    },
  },
  methods: {
    // 隐藏人脸核身
    hideDrawerTracking() {
      this.isTracking = false;
    },
    // 人脸核身功能
    successTracking() {
      this.isAdoptTracking = true;
      this.hideDrawerTracking();
      if (this.trackingType == 1) {
        this.confirm();
      } else {
        this.adjustmentConfirm();
      }
    },
    isVerifyFace(type = 1) {
      //1 没有监考， 2 有监考
      this.trackingType = type;
      if (this.$route.query.verifyFace == "true" && !this.isAdoptTracking) {
        this.isTracking = true;
        return false;
      }
      if (type == 1) {
        this.confirm();
      } else {
        this.adjustmentConfirm();
      }
    },
    // 网络状态监听
    setupNetworkListener() {
      window.addEventListener("online", this.handleNetworkOnline);
      window.addEventListener("offline", this.handleNetworkOffline);
    },
    handleNetworkOnline() {
      // 不显示消息，避免打断学员
      console.log("网络已恢复，等待3秒后同步");
      
      // 延迟3秒，确保网络稳定
      setTimeout(() => {
        // 先调用心跳接口，检查状态
        this.fetchHeartbeat();
      }, 3000);
    },
    handleNetworkOffline() {
      this.$message.warning({
        message: "网络连接已断开，请检查网络设置。请勿刷新页面！",
        duration: 0, // 不自动关闭
        showClose: true,
      });
    },
    cutPicture() {
      if (!this.localMediaStream) return;
      let v = document.querySelector("video");
      let canvas = document.getElementById("myCanvas");
      let ctx = canvas.getContext("2d");
      ctx.drawImage(v, 0, 0, 343, 200);
      let oGrayImg = canvas.toDataURL("image/jpeg", 0.7);
      let imgName = new Date().valueOf() + ".jpg";
      var file = dataURLtoFile(oGrayImg, imgName);

      // 上传视频截图
      let formData = new FormData();
      formData.append("file", file);
      this.$https
        .postWithFile(
          "/api/my/exam/upload/" + this.$route.query.examinationId,
          formData
        )
        .then((res) => {
          // 上传成功，重置失败计数
          this.uploadFailCount = 0;
          
          // 如果之前已降级，恢复正常频率
          if (this.isUploadDegraded) {
            this.isUploadDegraded = false;
            if (this.uploadTimer) {
              clearInterval(this.uploadTimer);
              this.uploadTimer = setInterval(this.cutPicture, 20000);
              console.log("图片上传频率已恢复到20秒");
            }
          }
          
          if (res.data.warning && res.data.message) {
            const now = Date.now();
            const message = res.data.message;
            
            // 防抖：如果警告消息相同且距离上次警告不足60秒，不重复弹出
            const isSameMessage = message === this.lastWarningMessage;
            const isWithinInterval = now - this.lastWarningTime < this.warningInterval;
            
            // 如果当前没有警告弹窗正在显示，且满足弹出条件，则弹出警告
            if (!this.isWarningDialogShowing && (!isSameMessage || !isWithinInterval)) {
              this.isWarningDialogShowing = true; // 标记弹窗正在显示
              
              this.$alert(message, "警告", {
                confirmButtonText: "知道了",
                callback: () => {
                  // 弹窗关闭后，重置标记
                  this.isWarningDialogShowing = false;
                }
              });
              
              // 更新上次警告信息
              this.lastWarningMessage = message;
              this.lastWarningTime = now;
            }
          } else if (!res.data.warning) {
            // 如果没有警告，清除上次警告记录（允许新的警告弹出）
            this.lastWarningMessage = "";
          }
          
          // 图片上传成功后，立即获取心跳数据（合并请求，降低服务器压力）
          this.fetchHeartbeatAfterUpload();
        })
        .catch((error) => {
          console.error("图片上传失败:", error);
          
          // 上传失败计数增加
          this.uploadFailCount++;
          
          // 连续失败3次，降级到60秒上传一次
          if (this.uploadFailCount >= 3 && !this.isUploadDegraded) {
            this.isUploadDegraded = true;
            if (this.uploadTimer) {
              clearInterval(this.uploadTimer);
              this.uploadTimer = setInterval(this.cutPicture, 60000);
              console.warn("图片上传频率已降级到60秒");
            }
          }
          
          // 上传失败时仍然调用心跳，确保时间同步
          this.fetchHeartbeatAfterUpload();
        });
      //将base64转换为文件
      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }
    },
    // 图片上传成功后获取心跳数据（复用图片上传作为心跳）
    fetchHeartbeatAfterUpload() {
      // 直接调用fetchHeartbeat，避免代码重复
      this.fetchHeartbeat();
    },
    closeWindow() {
      if (window.opener && !window.opener.closed) {
        try {
          window.opener.postMessage({ type: 'refresh-exam-list' }, '*');
        } catch (error) {}
      }
      window.onbeforeunload = null;
      window.close();
    },
    adjustmentConfirm() {
      this.initMonitoringQuietly()
        .catch(() => {
          /* 降级场景只需记录日志 */
        })
        .finally(() => {
        if (this.localMediaStream) {
          this.adjustment = false;
          this.startExame();
          // 恢复自动定时上传截图逻辑，每20秒上传一次
          this.uploadTimer = setInterval(this.cutPicture, this.setTimes);
        } else {
          this.$message.warning("请调整好摄像头之后再进入考试");
        }
        });
    },
    goback() {
      window.onbeforeunload = null;
      // 关闭监控会话
      this.closeMonitoringSession();
      this.$confirm("是否确定要退出考试？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$storage.setStorage([
            {
              key: "examination",
              value: 0,
            },
          ]);
          if (this.localMediaStream) {
            this.cancalCloseVideo();
          }
          this.closeWindow();
        })
        .catch((action) => {
          window.onbeforeunload = function () {
            return "您确定本页的操作完成了吗？页面将关闭或刷新。";
          };
        });
    },
    confirm() {
      this.dialogVisible = false;
      if (this.loginForm && this.status == 2) {
        this.adjustment = true;
      }
      if (this.loginForm) {
        this.openLocalMedia();
      } else {
        this.startExame();
      }
    },
    setTimer(initialSeconds) {
      if (typeof initialSeconds === "number") {
        this.totalTime = initialSeconds;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.updateTimerDisplay();
      this.countdownTimer = setInterval(() => {
        if (this.totalTime > 0) {
          this.totalTime--;
          this.updateTimerDisplay();
        } else {
          this.stopCountdown();
          if (this.uploadTimer) {
            window.clearInterval(this.uploadTimer);
            this.uploadTimer = null;
          }
          this.handleHeartbeatTimeout();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    updateTimerDisplay() {
      const total = Number(this.totalTime) || 0;
      const minute = parseInt(total / 60);
      const second = parseInt(total % 60);
      const pad = (num) => String(num).padStart(2, "0");
      this.timer = `${pad(minute)}:${pad(second)}`;
    },
    syncLeftTime(leftTime) {
      if (typeof leftTime === "number") {
        this.totalTime = leftTime;
        this.updateTimerDisplay();
        if (leftTime <= 0) {
          this.handleHeartbeatTimeout();
        }
      }
    },
    startHeartbeat() {
      this.stopHeartbeat();
      // 初始执行一次心跳
      this.fetchHeartbeat();
      // 图片上传每20秒执行一次，上传成功后会立即获取心跳数据
      // 这里设置一个较长的间隔作为兜底，防止图片上传失败时没有心跳
      // 正常情况下，心跳会在图片上传成功后立即执行，这个定时器只是作为备用
      // 使用heartbeatInterval的2倍作为兜底间隔，确保即使图片上传失败也能及时获取心跳
      this.heartbeatTimer = setInterval(() => {
        this.fetchHeartbeat();
      }, this.heartbeatInterval * 2); // 60秒兜底（heartbeatInterval * 2），避免图片上传失败时没有心跳
    },
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    fetchHeartbeat() {
      if (!this.examination || !this.examination.id) {
        return;
      }
      const url = this.currentSessionId 
        ? `/api/my/exam/heartbeat/${this.examination.id}?sessionId=${this.currentSessionId}`
        : `/api/my/exam/heartbeat/${this.examination.id}`;
      
      this.$https
        .get(url)
        .then((res) => {
          if (res.success && res.data) {
            const data = res.data;
            this.syncLeftTime(data.leftTime);
            
            // 检查是否被强制退出考场
            if (data.forceQuit === true) {
              this.handleSessionKicked();
              return;
            }
            
            // 检查题目索引是否一致（如果后端返回了subjectIndex）
            if (data.subjectIndex !== undefined && 
                data.subjectIndex !== this.examination.index) {
              console.warn("题目索引不一致，需要全量同步", {
                local: this.examination.index,
                server: data.subjectIndex
              });
              // 只有索引不一致时才全量同步
              this.startExame();
            } else {
              // 索引一致，只更新状态和时间
              if (data.status && data.status !== this.examination.status) {
                this.examination.status = data.status;
              }
              if (data.status && data.status !== "processing") {
                this.handleHeartbeatTimeout();
              }
            }
            
            // 检测token剩余时间，如果即将过期（2小时内）给出提示
            this.checkTokenExpiration();
          }
        })
        .catch(() => {
          // 忽略心跳异常，不影响答题
        });
    },
    // 检查token是否即将过期
    checkTokenExpiration() {
      try {
        const userInfoStr = sessionStorage.getItem("userInfo");
        if (!userInfoStr) return;
        
        const userInfo = JSON.parse(userInfoStr);
        const token = userInfo?.token;
        if (!token) return;
        
        // 如果token在2小时内过期，给出提示
        if (isTokenExpiringSoon(token, 7200)) {
          const remainingTime = getTokenRemainingTime(token);
          if (remainingTime !== null && remainingTime > 0) {
            const now = Date.now();
            // 防抖：如果距离上次警告不足5分钟，不重复输出控制台日志
            if (now - this.lastTokenWarningTime < this.tokenWarningInterval) {
              return;
            }
            
            const hours = Math.floor(remainingTime / 3600);
            const minutes = Math.floor((remainingTime % 3600) / 60);
            console.warn(`Token将在${hours}小时${minutes}分钟后过期，请及时保存考试进度`);
            // 可以在这里添加更明显的提示，比如Toast
            // this.$message.warning(`登录状态将在${hours}小时${minutes}分钟后过期，请及时保存考试进度`);
            
            this.lastTokenWarningTime = now;
          }
        }
      } catch (e) {
        console.error('检查token过期时间失败:', e);
      }
    },
    // 考试开始前检查token剩余时间
    checkTokenBeforeExam(examLeftTimeSeconds) {
      try {
        const userInfoStr = sessionStorage.getItem("userInfo");
        if (!userInfoStr) return;
        
        const userInfo = JSON.parse(userInfoStr);
        const token = userInfo?.token;
        if (!token) return;
        
        const tokenRemainingTime = getTokenRemainingTime(token);
        if (tokenRemainingTime === null) return;
        
        // 如果token剩余时间少于考试剩余时间+2小时（安全缓冲），给出警告
        const safeBuffer = 7200; // 2小时缓冲
        if (tokenRemainingTime < examLeftTimeSeconds + safeBuffer) {
          const tokenHours = Math.floor(tokenRemainingTime / 3600);
          const tokenMinutes = Math.floor((tokenRemainingTime % 3600) / 60);
          const examHours = Math.floor(examLeftTimeSeconds / 3600);
          const examMinutes = Math.floor((examLeftTimeSeconds % 3600) / 60);
          
          console.warn(
            `警告：登录状态将在${tokenHours}小时${tokenMinutes}分钟后过期，` +
            `但考试还需要${examHours}小时${examMinutes}分钟。` +
            `建议在考试前刷新登录状态。`
          );
          // 可以在这里添加更明显的提示
          // this.$message.warning(
          //   `登录状态将在${tokenHours}小时${tokenMinutes}分钟后过期，` +
          //   `但考试还需要${examHours}小时${examMinutes}分钟。` +
          //   `建议在考试前刷新登录状态。`
          // );
        }
      } catch (e) {
        console.error('检查token剩余时间失败:', e);
      }
    },
    handleHeartbeatTimeout() {
      if (this.isDone) {
        return;
      }
      this.stopHeartbeat();
      this.stopCountdown();
      this.closeMonitoringSession();
      this.isDone = true;
      this.$alert("考试时间已结束，系统将退出考试。", "提示", {
        confirmButtonText: "确定",
        center: true,
        callback: () => {
          this.cancalCloseVideo();
          this.closeWindow();
        },
      });
    },
    confirmSubmit() {
      this.status = 4;
    },
    async submit() {
      if (!this.hasAnswer) {
        this.$message.error("请先作答！");
        return;
      }
      this.submitIng = true;
      try {
        const res = await this.submitWithRetry();
        this.submitIng = false;
        
        // 提交成功，重置重试计数
        this.submitRetryCount = 0;
        
        if (res.success) {
          const data = res.data;
          this.isDone = data && data.isDone;
          
          // 添加调试日志
          console.log('[问卷调试] 提交题目后的返回数据:', {
            isDone: data.isDone,
            needQuestionnaire: data.needQuestionnaire,
            questionnaireFinished: data.questionnaireFinished,
            questionnaireTemplateCode: data.questionnaireTemplateCode,
            questionsFinished: data.questionsFinished,
            enableQuestionnaire: data.enableQuestionnaire
          });
          
          // 判断是否需要进入问卷阶段
          if (data.isDone && data.needQuestionnaire && !data.questionnaireFinished) {
            // 题目已完成，需要填写问卷
            console.log('[问卷调试] 进入问卷阶段');
            this.stopHeartbeat();
            this.stopCountdown();
            // 停止截图定时器和摄像头监控（考试答题阶段已结束）
            if (this.uploadTimer) {
              clearInterval(this.uploadTimer);
              this.uploadTimer = null;
            }
            this.closeMonitoringSession();
            this.cancalCloseVideo();
            // 进入问卷阶段
            this.showQuestionnaire = true;
            this.questionnaireTemplateCode = data.questionnaireTemplateCode;
            // 确保 examinationId 正确设置（使用 examination.id 或 examinationId）
            if (!this.examinationId && this.examination && this.examination.id) {
              this.examinationId = this.examination.id;
            }
            // 保存 examination 基本信息
            this.examination = {
              ...this.examination,
              ...data
            };
            // 再次确保 examinationId 正确（从返回的数据中获取）
            if (data.id && !this.examinationId) {
              this.examinationId = data.id;
            }
            console.log('[问卷调试] 问卷参数设置:', {
              showQuestionnaire: this.showQuestionnaire,
              examinationId: this.examinationId,
              questionnaireTemplateCode: this.questionnaireTemplateCode
            });
            return;
          }
          
          // 如果题目已完成但没有进入问卷阶段，记录原因
          if (data.isDone) {
            console.warn('[问卷调试] 题目已完成但未进入问卷阶段，原因:', {
              needQuestionnaire: data.needQuestionnaire,
              questionnaireFinished: data.questionnaireFinished,
              questionnaireTemplateCode: data.questionnaireTemplateCode
            });
          }
          
          if (!data.isDone) {
            this.examination = {
              ...data,
              value: data.subject.type == "MC" ? [] : null,
            };
            this.setTimer(data.leftTime);
          } else {
            this.stopHeartbeat();
            this.stopCountdown();
            // 关闭监控会话
            this.closeMonitoringSession();
            /*是否回显*/
            if (data.needDisplay) {
              const contentVNode = this.buildResultContentVNode(data);
              this.$confirm(contentVNode, "", {
                confirmButtonText: "确定",
                showCancelButton: false,
                showClose: false,
                dangerouslyUseHTMLString: false,
                center: true,
              })
                .then(() => {
                  this.cancalCloseVideo();
                  this.closeWindow();
                })
                .catch(() => {
                  this.cancalCloseVideo();
                  this.closeWindow();
                });
            } else {
              this.$alert("", "考试完成！", {
                confirmButtonText: "确定",
                center: true,
                callback: () => {
                  this.cancalCloseVideo();
                  this.closeWindow();
                },
              });
            }
          }
        }
      } catch (error) {
        this.submitIng = false;
        this.handleSubmitError(error);
      }
    },
    // 提交重试机制
    async submitWithRetry(retryCount = 0) {
      try {
        const res = await this.$https.post(
          "/api/my/exam/submitsubject/" + this.examination.id,
          {
            answer: this.examination.value,
            subjectIndex: this.examination.index,
          }
        );
        return res;
      } catch (error) {
        // 业务错误不重试
        if (error.code === "business_error") {
          throw error;
        }
        // 超过最大重试次数不再重试
        if (retryCount >= this.MAX_RETRY_COUNT) {
          throw error;
        }
        console.warn(`提交失败，正在重试 (${retryCount + 1}/${this.MAX_RETRY_COUNT})...`);
        // 延迟后重试
        await new Promise((resolve) => setTimeout(resolve, this.RETRY_DELAY));
        return this.submitWithRetry(retryCount + 1);
      }
    },
    // 统一错误处理
    handleSubmitError(error) {
      if (error.code == "business_error") {
        // 如果是提交题目序号错误，自动同步状态
        // 优先检查错误码，如果没有则回退到字符串匹配
        const isIndexError = error.errorCode === "EXAM_INDEX_MISMATCH" || 
                           (error.debug && error.debug.includes("提交题目序号错误"));
        
        if (isIndexError) {
          // 检查是否同一题目反复失败
          if (this.currentSubjectIndex === this.examination.index) {
            this.submitRetryCount++;
          } else {
            this.currentSubjectIndex = this.examination.index;
            this.submitRetryCount = 1;
          }
          
          // 超过3次重试，禁止继续
          if (this.submitRetryCount > 3) {
            this.$alert(
              "题目提交多次失败，请联系监考老师。您可以继续答题，稍后再尝试提交。",
              "提示",
              {
                confirmButtonText: "我知道了",
                callback: () => {
                  // 重置重试计数
                  this.submitRetryCount = 0;
                }
              }
            );
            return;
          }
          
          this.$message.warning(`考试状态不同步，正在刷新...（${this.submitRetryCount}/3）`);
          // 重新获取考试状态
          this.startExame();
          return;
        }
        
        this.$message.error(error.debug || error.message || "操作失败");
        if (this.uploadTimer) {
          clearInterval(this.uploadTimer);
          this.uploadTimer = null;
        }
      } else if (
        error.code == "not_found" &&
        error.debug && error.debug.includes("强制退出")
      ) {
        this.$router.push({
          path: "/tipsPage",
        });
      } else {
        // 网络错误提示
        if (error.message && error.message.includes("Network")) {
          this.$message.error("网络连接失败，请检查网络");
        } else {
          this.$message.error(error.debug || error.message || "提交失败");
        }
      }
    },
    // 关闭摄像头
    cancalCloseVideo() {
      if (this.localMediaStream) {
        try {
          // 停止所有轨道
          const tracks = this.localMediaStream.getTracks();
          tracks.forEach((track) => {
            track.stop();
            console.log(`停止媒体轨道: ${track.kind}`);
          });
          
          // 清空引用
          this.localMediaStream = null;
          
          // 清空视频元素（防止内存泄漏）
          const localVideo = document.getElementById("localVideo");
          if (localVideo) {
            localVideo.srcObject = null;
            localVideo.load(); // 重置video元素
          }
        } catch (e) {
          console.error('清理媒体流失败:', e);
        }
      }
    },
    // 连接服务
    connSocket() {
      this.safeInitPeer();
    },

    initMonitoringQuietly() {
      if (!this.loginForm) {
        return Promise.resolve({ status: "skipped" });
      }
      return Promise.resolve()
        .then(() => {
          const success = this.safeInitPeer();
          if (!success) {
            this.logMonitoringEvent("warn", "实时监控初始化失败，已降级继续考试");
          }
          return { status: success ? "initialized" : "failed" };
        })
        .catch((error) => {
          this.handleMonitoringFailure("初始化实时监控失败", error);
          return { status: "failed" };
        });
    },

    safeInitPeer() {
      try {
        this.initPeer();
        return true;
      } catch (error) {
        this.handleMonitoringFailure("初始化实时监控失败", error);
        return false;
      }
    },

    handleMonitoringFailure(message, error) {
      if (!this.monitoringDegraded) {
        this.monitoringDegraded = true;
      }
      this.logMonitoringEvent("error", message || "实时监控异常", error);
    },
    logMonitoringEvent(level = "info", message = "", error = null) {
      const logger = console[level] || console.log;
      const payload = {
        timestamp: new Date().toISOString(),
        message: message || "实时监控事件",
      };
      if (error) {
        payload.error = error;
      }
      logger(`${this.monitoringLogPrefix}`, payload);
    },
    // 创建监控会话
    createMonitoringSession() {
      if (!this.examination || !this.examination.id) {
        return;
      }
      try {
        // 获取设备信息
        const deviceInfo = {
          browser: this.getBrowserInfo(),
          os: this.getOSInfo(),
          userAgent: navigator.userAgent
        };
        
        this.$https.post(`/api/my/exam/${this.examination.id}/sessions`, deviceInfo)
          .then((res) => {
            if (res.success && res.data && res.data.sessionId) {
              this.currentSessionId = res.data.sessionId;
              this.sessionHeartbeatEnabled = true;
              this.logMonitoringEvent("info", "监控会话创建成功", { sessionId: this.currentSessionId });
              
              // 如果 PeerJS 已经初始化完成，立即上报 PeerID
              if (this.peers && this.peers.id) {
                this.logMonitoringEvent("info", "会话创建成功，PeerJS已初始化，立即上报PeerID", {
                  sessionId: this.currentSessionId,
                  peerId: this.peers.id
                });
                this.reportPeerConnectionId(this.peers.id);
              } else {
                this.logMonitoringEvent("info", "会话创建成功，但PeerJS尚未初始化", {
                  sessionId: this.currentSessionId,
                  hasPeers: !!this.peers,
                  peerId: this.peers?.id
                });
              }
            } else {
              this.logMonitoringEvent("warn", "创建监控会话失败，继续考试", res);
            }
          })
          .catch((error) => {
            this.logMonitoringEvent("warn", "创建监控会话失败，继续考试", error);
          });
      } catch (error) {
        this.logMonitoringEvent("warn", "创建监控会话异常，继续考试", error);
      }
    },
    // 上报会话PeerID
    reportPeerConnectionId(peerConnectionId) {
      this.logMonitoringEvent("info", "尝试上报会话PeerID", {
        peerConnectionId,
        currentSessionId: this.currentSessionId,
        examId: this.examination?.id
      });
      
      if (!this.currentSessionId || !this.examination || !this.examination.id) {
        this.logMonitoringEvent("warn", "上报会话PeerID失败：缺少必要参数", {
          hasSessionId: !!this.currentSessionId,
          hasExamination: !!this.examination,
          hasExamId: !!this.examination?.id
        });
        return;
      }
      
      if (!peerConnectionId) {
        this.logMonitoringEvent("warn", "上报会话PeerID失败：PeerID为空");
        return;
      }
      
      try {
        this.$https.put(`/api/my/exam/${this.examination.id}/sessions/${this.currentSessionId}/peer`, {
          peerConnectionId: peerConnectionId
        })
          .then((res) => {
            if (res.success) {
              this.logMonitoringEvent("info", "会话PeerID上报成功", {
                sessionId: this.currentSessionId,
                peerConnectionId: peerConnectionId
              });
            } else {
              this.logMonitoringEvent("warn", "上报会话PeerID失败：后端返回失败", res);
            }
          })
          .catch((error) => {
            this.logMonitoringEvent("error", "上报会话PeerID失败：请求异常", error);
          });
      } catch (error) {
        this.logMonitoringEvent("error", "上报会话PeerID异常", error);
      }
    },
    // 关闭监控会话
    closeMonitoringSession() {
      if (!this.currentSessionId || !this.examination || !this.examination.id) {
        return;
      }
      try {
        this.$https.delete(`/api/my/exam/${this.examination.id}/sessions/${this.currentSessionId}`)
          .then(() => {
            this.logMonitoringEvent("info", "监控会话已关闭");
          })
          .catch((error) => {
            this.logMonitoringEvent("warn", "关闭监控会话失败", error);
          });
      } catch (error) {
        this.logMonitoringEvent("warn", "关闭监控会话异常", error);
      }
    },
    // 被踢出考场处理
    handleSessionKicked() {
      this.logMonitoringEvent("error", "你已被管理员踢出考场");
      this.$message.error("你已被管理员踢出考场，考试已结束");
      
      // 强制退出考试
      this.closeMonitoringSession();
      this.cancalCloseVideo();
      
      // 停止心跳
      this.stopHeartbeat();
      
      // 跳转回考试列表
      setTimeout(() => {
        this.$router.push({ path: "/examination" });
      }, 2000);
    },
    // 获取浏览器信息
    getBrowserInfo() {
      const ua = navigator.userAgent;
      if (ua.indexOf("Chrome") > -1) return "Chrome";
      if (ua.indexOf("Firefox") > -1) return "Firefox";
      if (ua.indexOf("Safari") > -1) return "Safari";
      if (ua.indexOf("Edge") > -1) return "Edge";
      return "Unknown";
    },
    // 获取操作系统信息
    getOSInfo() {
      const ua = navigator.userAgent;
      if (ua.indexOf("Windows") > -1) return "Windows";
      if (ua.indexOf("Mac") > -1) return "Mac";
      if (ua.indexOf("Linux") > -1) return "Linux";
      if (ua.indexOf("Android") > -1) return "Android";
      if (ua.indexOf("iOS") > -1) return "iOS";
      return "Unknown";
    },

    // 打开本地音视频,用promise这样在打开视频成功后，再进行下一步操作
    openLocalMedia() {
      // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      // 先请求权限
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(() => {
          //枚举设备
          var devices = navigator.mediaDevices
            .enumerateDevices()
            .then((devicesList) => {
              var filtered = devicesList.filter(
                (device) => device.kind === "videoinput"
              );
              console.log(devicesList);
              console.log(filtered);
              if (filtered.length > 0) {
                this.filtered = filtered;
                this.filteredValue = 0;
                navigator.mediaDevices
                  .getUserMedia({ audio: true })
                  .then(() => {
                    this.isAudioOK = true;
                    this.mediaConstraints = {
                      audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true,
                        sampleRate: 16000,
                        channelCount: 1
                      },
                      video: { 
                        deviceId: { exact: filtered[0].deviceId },
                        width: { ideal: 640, min: 320, max: 1280 },
                        height: { ideal: 480, min: 240, max: 720 },
                        frameRate: { ideal: 15, max: 20 },
                        aspectRatio: 4/3,
                        facingMode: "user"
                      },
                    };
                    this.getUserMediaPlay();
                  })
                  .catch(() => {
                    this.isAudioOK = false;
                    this.mediaConstraints = {
                      video: { 
                        deviceId: { exact: filtered[0].deviceId },
                        width: { ideal: 640, min: 320, max: 1280 },
                        height: { ideal: 480, min: 240, max: 720 },
                        frameRate: { ideal: 15, max: 20 },
                        aspectRatio: 4/3,
                        facingMode: "user"
                      },
                    };
                    this.getUserMediaPlay();
                    console.log("音频异常");
                  });
              } else {
                // 未检测到摄像头设备的详细引导
                this.$confirm(
                  `<div style="text-align: left; line-height: 2;">
                    <p><strong>未检测到摄像头设备，请检查：</strong></p>
                    <ul>
                      <li>摄像头是否正确连接到电脑</li>
                      <li>摄像头驱动是否正常安装</li>
                      <li>其他软件是否占用摄像头</li>
                    </ul>
                    <p style="color: #ff4d4f;">本场考试需要视频监控，无法使用摄像头将无法参加考试</p>
                  </div>`,
                  "摄像头访问失败",
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "重新尝试",
                    cancelButtonText: "返回",
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                  }
                ).then(() => {
                  // 点击"重新尝试"
                  this.openLocalMedia();
                }).catch(() => {
                  // 点击"返回"
                  this.$router.push({ path: "/examination" });
                });
              }
            });
        })
        .catch((err) => {
          console.error("getUserMedia error:", err);
          
          // 详细的错误提示和引导
          let errorTitle = "摄像头访问失败";
          let errorMessage = "";
          let showRetry = true;
          let showContactAdmin = false;
          
          switch(err.name) {
            case "NotAllowedError":
            case "PermissionDeniedError":
              errorMessage = `
                <div style="text-align: left; line-height: 2;">
                  <p><strong>浏览器权限未开启，请按以下步骤操作：</strong></p>
                  <ol>
                    <li>点击地址栏左侧的<strong>锁形图标</strong>或<strong>摄像头图标</strong></li>
                    <li>选择"<strong>始终允许</strong> ${window.location.hostname} 访问摄像头和麦克风"</li>
                    <li>点击下方"<strong>重新尝试</strong>"按钮</li>
                  </ol>
                  <img src="../../../assets/imgs/tips_01.png" style="width: 100%; margin: 10px 0;" />
                  <p style="color: #ff4d4f;">如果仍无法访问，请尝试刷新页面或联系管理员</p>
                </div>
              `;
              break;
              
            case "NotFoundError":
            case "DevicesNotFoundError":
              errorMessage = `
                <div style="text-align: left; line-height: 2;">
                  <p><strong>未检测到摄像头设备，请检查：</strong></p>
                  <ul>
                    <li>摄像头是否正确连接到电脑</li>
                    <li>摄像头驱动是否正常安装</li>
                    <li>其他软件是否占用摄像头</li>
                  </ul>
                  <p style="color: #ff4d4f;">本场考试需要视频监控，无法使用摄像头将无法参加考试</p>
                </div>
              `;
              showContactAdmin = true;
              break;
              
            case "NotReadableError":
            case "TrackStartError":
              errorMessage = `
                <div style="text-align: left; line-height: 2;">
                  <p><strong>摄像头被其他程序占用，请：</strong></p>
                  <ul>
                    <li>关闭其他正在使用摄像头的软件（如QQ、微信、钉钉等）</li>
                    <li>如果使用了虚拟摄像头软件，请先关闭</li>
                    <li>关闭后点击"<strong>重新尝试</strong>"</li>
                  </ul>
                </div>
              `;
              break;
              
            case "OverconstrainedError":
            case "ConstraintNotSatisfiedError":
              errorMessage = "摄像头不支持当前分辨率，正在尝试降低要求...";
              showRetry = false;
              // 自动降级：尝试更低的分辨率
              setTimeout(() => {
                this.mediaConstraints = {
                  video: { width: 640, height: 480 },
                  audio: true
                };
                this.openLocalMedia();
              }, 1000);
              return; // 不显示对话框，直接重试
              
            default:
              // 检查是否是浏览器不支持的错误
              if (err.message && err.message.includes("getUserMedia is not implemented")) {
                // 检查是否是HTTP协议导致的问题
                const isHttp = window.location.protocol === 'http:' && 
                              window.location.hostname !== 'localhost' && 
                              window.location.hostname !== '127.0.0.1';
                
                if (isHttp) {
                  errorMessage = `
                    <div style="text-align: left; line-height: 2;">
                      <p><strong style="color: #d9534f;">⚠️ 安全协议错误！</strong></p>
                      <p style="margin: 15px 0;">Chrome浏览器要求使用 <strong style="color: #52c41a;">HTTPS安全协议</strong> 才能访问摄像头。</p>
                      <p style="padding: 15px; background-color: #fff3cd; border-left: 4px solid #ffc107;">
                        <strong>当前访问地址：</strong><br/>
                        <code style="color: #d9534f; font-size: 14px;">${window.location.href}</code><br/><br/>
                        <strong>请改用以下方式访问：</strong><br/>
                        <code style="color: #52c41a; font-size: 14px;">https://${window.location.host}${window.location.pathname}</code>
                      </p>
                      <p style="margin-top: 15px; font-size: 14px;">
                        <strong>解决方法：</strong><br/>
                        1. 在地址栏将 <code style="color: #d9534f;">http://</code> 改为 <code style="color: #52c41a;">https://</code><br/>
                        2. 或联系管理员配置HTTPS证书
                      </p>
                    </div>
                  `;
                } else {
                  errorMessage = `
                    <div style="text-align: left; line-height: 2;">
                      <p><strong>您的浏览器不支持摄像头功能！</strong></p>
                      <p style="color: #ff4d4f; margin: 15px 0;">请使用以下浏览器之一：</p>
                      <ul style="font-size: 16px;">
                        <li><strong>Chrome 浏览器</strong>（推荐，版本 53 或更高）</li>
                        <li><strong>Firefox 火狐浏览器</strong>（版本 36 或更高）</li>
                        <li><strong>Edge 浏览器</strong>（版本 79 或更高）</li>
                        <li><strong>Safari 浏览器</strong>（版本 11 或更高，仅 macOS）</li>
                      </ul>
                      <p style="margin-top: 15px; padding: 10px; background-color: #fff3cd; border-left: 4px solid #ffc107;">
                        <strong>⚠️ 重要提示：</strong><br/>
                        • 请勿使用 <strong style="color: #d9534f;">IE浏览器</strong>（已不支持）<br/>
                        • 建议使用最新版本的 Chrome 浏览器
                      </p>
                      <p style="margin-top: 10px;">下载 Chrome 浏览器：<a href="https://www.google.cn/chrome/" target="_blank" style="color: #1890ff;">https://www.google.cn/chrome/</a></p>
                    </div>
                  `;
                }
                showRetry = false;
                showContactAdmin = true;
              } else {
                errorMessage = `<div style="text-align: left;">
                  <p>摄像头访问失败，错误信息：${err.message}</p>
                  <p style="color: #ff4d4f;">请尝试刷新页面或联系管理员</p>
                </div>`;
                showContactAdmin = true;
              }
          }
          
          // 显示错误对话框
          this.$confirm(errorMessage, errorTitle, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: showRetry ? "重新尝试" : "我知道了",
            cancelButtonText: showContactAdmin ? "返回" : "取消",
            showCancelButton: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
          }).then(() => {
            // 点击"重新尝试"
            if (showRetry) {
              this.openLocalMedia();
            }
          }).catch(() => {
            // 点击"返回"或"取消"
            this.$router.push({ path: "/examination" });
          });
        });
    },
    buildResultContentVNode(data) {
      const h = this.$createElement;
      let tipsTxt = "很遗憾，您没有通过此次考试";
      let tipsTxtClass = "echoErrorTitle";
      if (data.pass) {
        tipsTxt = "恭喜您通过此次考试";
        tipsTxtClass = "echoPassTitle";
      }
      const displayContentText = data.displayContent || "";
      const src = data.displayImage ? this.$domainName + data.displayImage : "";
      return h(
        "div",
        { class: "echoPass" },
        [
          h("div", { class: tipsTxtClass }, tipsTxt),
          displayContentText
            ? h("div", { class: "echoPassContent" }, displayContentText)
            : null,
          src
            ? h("img", {
                style: "max-width:100%;",
                attrs: { src, alt: "考试结果" },
              })
            : null,
        ].filter(Boolean)
      );
    },
    // 选择调用打开本地音视频设备
    selectGetUserMediaPlay(filteredIndex) {
      console.log(filteredIndex);
      if (!this.filtered || filteredIndex < 0 || filteredIndex >= this.filtered.length) {
        this.$message.warning("设备不可用或已移除");
        return;
      }
      // 停止旧流，释放设备占用
      if (this.localMediaStream) {
        try {
          this.localMediaStream.getTracks().forEach((t) => t.stop());
        } catch (e) {}
      }
      let filteredItem = this.filtered[filteredIndex];
      this.filteredValue = filteredIndex;
      this.mediaConstraints = {
        audio: this.isAudioOK,
        video: { deviceId: { exact: filteredItem.deviceId } },
      };
      this.getUserMediaPlay(true);
    },
    // 调用打开本地音视频设备
    getUserMediaPlay(isSelect) {
      var errBack = (e) => {
        console.log("An error has occurred!", e);
        this.$message.warning("打开本地音视频设备失败" + e.message);
      };
      let localVideo = document.getElementById("localVideo");
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        console.log("navigator.mediaDevices.getUserMedia");
        console.log(this.mediaConstraints);
        navigator.mediaDevices
          .getUserMedia(this.mediaConstraints)
          .then((stream) => {
            this.localMediaStream = stream;
            try {
              localVideo.srcObject = stream;
            } catch (error) {
              localVideo.src = URL.createObjectURL(stream);
            }
            localVideo.onloadedmetadata = function () {
              localVideo.play();
            };
            if (isSelect) {
              this.$message({
                message: "切换设备成功",
                type: "success",
              });
            }
            this.watchStream(1000);
          })
          .catch((err) => {
            console.log(err);
            this.$message.warning("打开本地音视频设备失败" + err.message);
          });
      } else if (navigator.getUserMedia) {
        console.log("navigator.getUserMedia");
        navigator.getUserMedia(
          this.mediaConstraints,
          (stream) => {
            this.localMediaStream = stream;
            try {
              localVideo.srcObject = stream;
            } catch (error) {
              localVideo.src = URL.createObjectURL(stream);
            }
            localVideo.play();
            if (isSelect) {
              this.$message({
                message: "切换设备成功",
                type: "success",
              });
            }
            this.watchStream(1000);
          },
          errBack
        );
      } else if (navigator.webkitGetUserMedia) {
        console.log("navigator.webkitGetUserMedia");
        navigator.webkitGetUserMedia(
          this.mediaConstraints,
          (stream) => {
            this.localMediaStream = stream;
            try {
              localVideo.srcObject = stream;
            } catch (error) {
              localVideo.src = URL.createObjectURL(stream);
            }
            localVideo.play();
            if (isSelect) {
              this.$message({
                message: "切换设备成功",
                type: "success",
              });
            }
            this.watchStream(1000);
          },
          errBack
        );
      } else if (navigator.mozGetUserMedia) {
        console.log("navigator.mozGetUserMedia");
        navigator.mozGetUserMedia(
          this.mediaConstraints,
          (stream) => {
            this.localMediaStream = stream;
            try {
              localVideo.srcObject = stream;
            } catch (error) {
              localVideo.src = URL.createObjectURL(stream);
            }
            localVideo.play();
            if (isSelect) {
              this.$message({
                message: "切换设备成功",
                type: "success",
              });
            }
            this.watchStream(1000);
          },
          errBack
        );
      }
    },
    watchStream(timer) {
      const _this = this;
      if (_timer) {
        clearInterval(_timer);
      }
      _timer = setInterval(function () {
        if (!_this.localMediaStream || _this.localMediaStream.getTracks().length === 0) {
          return;
        }
        const lives = _this.localMediaStream.getTracks()[0];
        if (lives.readyState == "ended" && !_this.isDone) {
          clearInterval(_timer);
          _this
            .$confirm("摄像头异常，考试可能无效！", "提示", {
              confirmButtonText: "确定",
              showCancelButton: false,
              showConfirmButton: false,
              type: "warning",
              center: true,
            })
            .then(() => {
              // _this.$router.go(-1);
              // _this.connSocket();
            });
        }
      }, timer);
    },
    initPeer() {
      try {
        // 检查loginForm是否存在，避免报错
        if (!this.loginForm || !this.loginForm.userId) {
          console.warn("initPeer: loginForm 或 userId 不存在，无法初始化 Peer");
          return;
        }
        
        // 使用 userId_timestamp 作为PeerID，确保同机考试时不冲突
        const peerId = this.loginForm.userId + "_" + Date.now();
        console.log("initPeer with PeerID:", peerId);
        
        // 根据页面协议自动选择安全连接（HTTPS页面必须使用WSS）
        const isSecure = window.location.protocol === 'https:';
        
        this.peers = new Peer(peerId, {
          debug: 2,
          host: "peer.gdcoh.com",
          port: 443,
          path: "/myapp",
          secure: true,
          config: {
            iceServers: [
              { urls: "stun:stun.l.google.com:19302" },
              { urls: "stun:meeting.gdcoh.com:3478" },
              {
                urls: "turn:meeting.gdcoh.com:3478?transport=tcp",
                username: "kurento",
                credential: "kurento",
              },
              {
                urls: "turn:meeting.gdcoh.com:3478?transport=udp",
                username: "kurento",
                credential: "kurento",
              },
            ],
            iceTransportPolicy: 'all',
            iceCandidatePoolSize: 10,
            bundlePolicy: 'max-bundle',
            rtcpMuxPolicy: 'require',
          },
        });
        
        this.peers.on("open", (id) => {
          console.log("Peer连接成功，PeerID:", id);
          this.logMonitoringEvent("info", "Peer连接成功", {
            peerId: id,
            currentSessionId: this.currentSessionId,
            examId: this.examination?.id
          });
          
          // 重连成功，重置重连计数
          this.peerReconnectAttempts = 0;
          
          // 上报PeerID到后端（兼容旧接口）
          if (this.examination && this.examination.id) {
            this.$https.post(`/api/my/exam/${this.examination.id}/peer`, {
              peerConnectionId: id
            }).then(() => {
              console.log("PeerID上报成功（旧接口）");
              this.logMonitoringEvent("info", "PeerID上报成功（旧接口）");
            }).catch(err => {
              this.handleMonitoringFailure("上报PeerID失败", err);
            });
          }
          
          // 如果存在会话ID，上报到会话
          // 如果会话ID还未创建，等待一下再尝试上报
          if (this.currentSessionId && this.examination && this.examination.id) {
            this.logMonitoringEvent("info", "会话ID已存在，立即上报PeerID到会话");
            this.reportPeerConnectionId(id);
          } else if (this.examination && this.examination.id) {
            // 会话ID可能还在创建中，延迟重试（最多重试5次，每次间隔2秒）
            this.logMonitoringEvent("info", "会话ID未创建，开始延迟重试上报PeerID");
            let retryCount = 0;
            const maxRetries = 5;
            const retryInterval = 2000;
            
            const retryReport = () => {
              if (this.currentSessionId && this.examination && this.examination.id) {
                this.reportPeerConnectionId(id);
                this.logMonitoringEvent("info", `延迟上报PeerID成功（第${retryCount + 1}次重试）`);
              } else if (retryCount < maxRetries) {
                retryCount++;
                this.logMonitoringEvent("info", `会话ID仍未创建，${retryInterval/1000}秒后进行第${retryCount + 1}次重试`);
                setTimeout(retryReport, retryInterval);
              } else {
                this.logMonitoringEvent("warn", "延迟重试失败：已达到最大重试次数", {
                  maxRetries,
                  hasSessionId: !!this.currentSessionId,
                  hasExamination: !!this.examination,
                  hasExamId: !!this.examination?.id
                });
              }
            };
            
            setTimeout(retryReport, retryInterval);
          } else {
            this.logMonitoringEvent("warn", "无法上报PeerID到会话：缺少必要信息", {
              hasSessionId: !!this.currentSessionId,
              hasExamination: !!this.examination,
              hasExamId: !!this.examination?.id
            });
          }
        });
        
        this.peers.on("error", (error) => {
          console.error("Peer连接错误:", error);
          
          // 智能重连策略
          if (error.type === "network" || error.type === "disconnected") {
            if (this.peerReconnectAttempts < this.maxPeerReconnectAttempts && !this.isDone) {
              this.peerReconnectAttempts++;
              
              // 指数退避：5s, 10s, 20s, 40s, 80s，最大60秒
              const delay = this.peerReconnectDelay * Math.pow(2, this.peerReconnectAttempts - 1);
              const maxDelay = 60000; // 最大60秒
              const actualDelay = Math.min(delay, maxDelay);
              
              console.warn(`Peer网络错误，${actualDelay/1000}秒后尝试第${this.peerReconnectAttempts}次重连`);
              
              setTimeout(() => {
                if (this.loginForm && !this.isDone) {
                  console.log("尝试重新初始化Peer连接");
                  
                  // 先销毁旧实例
                  if (this.peers) {
                    try {
                      this.peers.destroy();
                    } catch (e) {
                      console.error('销毁旧Peer实例失败:', e);
                    }
                    this.peers = null;
                  }
                  
                  // 再重新初始化
                  this.safeInitPeer();
                }
              }, actualDelay);
            } else {
              this.handleMonitoringFailure("Peer重连次数已达上限或考试已结束，停止重连");
              // 注意：这里不弹出错误提示，避免打断学员答题
              // 监控功能失败不应影响考试继续
            }
          } else if (error.type === "peer-unavailable") {
            // 对方不在线，不重连
            console.warn("监考端不在线");
          } else {
            // 其他错误
            this.handleMonitoringFailure("Peer未知错误", error);
          }
        });
        
      this.peers.on("disconnected", () => {
        console.warn("Peer连接断开");
        // 尝试重新连接（reconnect比destroy+new更轻量）
        if (!this.isDone && this.peers) {
          console.log("尝试重新连接Peer");
          try {
            this.peers.reconnect();
          } catch (e) {
            console.error('Peer reconnect失败:', e);
          }
        }
      });
      
      this.peers.on("connection", (conn) => {
        const invigilatorId = conn.peer;
        console.log(`收到监考端连接请求: ${invigilatorId}`);
        
        // 检查是否超过最大监考员数量
        if (this.activeCalls.size >= this.maxInvigilators) {
          console.warn(`监控人数已达上限(${this.maxInvigilators})，拒绝新连接`);
          conn.send({ type: 'REJECT', reason: '监考员数量已满' });
          conn.close();
          return;
        }
        
        conn.on("data", (data) => {
          console.log(`收到监考端数据 [${invigilatorId}]:`, data);
          
          if (data.type != null) {
            if (data.type === "V") {
              // 使用同一个 localMediaStream，避免重复调用 getUserMedia
              const call = this.peers.call(data.id, this.localMediaStream);
              
              // 记录活跃的通话
              this.activeCalls.set(invigilatorId, {
                conn,
                call,
                connectTime: Date.now()
              });
              
              console.log(`向监考端 [${invigilatorId}] 发起视频通话，当前监控人数: ${this.activeCalls.size}`);
              
              // 监听通话关闭
              call.on('close', () => {
                this.activeCalls.delete(invigilatorId);
                console.log(`监考端 [${invigilatorId}] 断开连接，剩余监控人数: ${this.activeCalls.size}`);
              });
              
            } else if (data.type === "M") {
              this.$message.warning(data.msg);
              console.log(`收到监考消息 [${invigilatorId}]:`, data.msg);
            }
          }
        });
        
        conn.on("open", () => {
          console.log(`与监考端 [${invigilatorId}] 数据通道已建立`);
        });
        
        conn.on("close", () => {
          this.activeCalls.delete(invigilatorId);
          console.log(`监考端 [${invigilatorId}] 连接关闭`);
        });
      });
      } catch (error) {
        this.handleMonitoringFailure("初始化实时监控失败", error);
      }
    },
    startExame() {
      const query = this.$route.query || null;
      if (!query) {
        this.$router.push({
          path: "/examination",
        });
      }
      this.examinationId = query.examinationId;
      this.$https
        .post("/api/my/exam/start/" + query.examinationId)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            
            // 添加调试日志
            console.log('[问卷调试] 开始考试时的返回数据:', {
              needQuestionnaire: data.needQuestionnaire,
              questionsFinished: data.questionsFinished,
              questionnaireFinished: data.questionnaireFinished,
              questionnaireTemplateCode: data.questionnaireTemplateCode,
              enableQuestionnaire: data.enableQuestionnaire
            });
            
            // 判断是否需要进入问卷阶段
            if (data.needQuestionnaire && data.questionsFinished && !data.questionnaireFinished) {
              // 需要填写问卷，直接进入问卷阶段
              console.log('[问卷调试] 开始考试时进入问卷阶段');
              this.showQuestionnaire = true;
              this.questionnaireTemplateCode = data.questionnaireTemplateCode;
              // 保存 examination 基本信息（用于返回时使用）
              this.examination = {
                id: data.id,
                ...data
              };
              return;
            }
            
            // 正常进入考试题阶段
            if (!data.subject) {
              this.tips = "考试数据异常！";
              return;
            }
            this.examination = {
              ...data,
              value: data.subject.type == "MC" ? [] : null,
            };
            this.showQuestionnaire = false;
            this.endTime = moment(data.studentExpireDate).format("HH:mm:ss");
            this.setTimer(data.leftTime);
            this.startHeartbeat();
            
            // 检查token剩余时间，如果少于考试剩余时间+2小时，给出警告
            this.checkTokenBeforeExam(data.leftTime);
            
            // 异步创建监控会话，失败不影响考试
            this.createMonitoringSession();
          } else {
            this.dialogVisible = true;
            this.status = 1;
            this.erroring = true;
            this.tips = "错误：" + (res.message || res.debug || "未知错误");
            return;
          }
        })
        .catch((error) => {
          this.dialogVisible = true;
          this.status = 1;
          this.erroring = true;
          this.tips = "错误：" + (error.debug || error.message || "未知错误");
          return;
        });
    },
    watchStream(timer) {
      const _this = this;
      if (_timer) {
        clearInterval(_timer);
      }
      _timer = setInterval(function () {
        const lives = _this.localMediaStream.getTracks()[0];
        if (lives.readyState == "ended" && !this.isDone) {
          clearInterval(_timer);
          _this
            .$confirm("摄像头异常，考试可能无效！", "提示", {
              confirmButtonText: "确定",
              showCancelButton: false,
              showConfirmButton: false,
              type: "warning",
              center: true,
            })
            .then(() => {
              // _this.$router.go(-1);
              // _this.connSocket();
            });
        }
      }, timer);
    },
    
    // 问卷提交成功处理
    handleQuestionnaireSubmit() {
      // 问卷提交成功后，重新加载考试状态，查看结果
      this.showQuestionnaire = false;
      // 停止所有定时器
      this.stopHeartbeat();
      this.stopCountdown();
      // 关闭监控会话
      this.closeMonitoringSession();
      
      // 重新获取考试状态，查看成绩和证书
      const query = this.$route.query || null;
      if (!query || !query.examinationId) {
        console.error('无法获取考试ID');
        this.$alert("", "考试完成！", {
          confirmButtonText: "确定",
          center: true,
          callback: () => {
            this.cancalCloseVideo();
            this.closeWindow();
          },
        });
        return;
      }
      
      this.$https
        .post("/api/my/exam/start/" + query.examinationId)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            // 此时应该已经完成问卷，显示结果
            if (data.needDisplay) {
              const contentVNode = this.buildResultContentVNode(data);
              this.$confirm(contentVNode, "", {
                confirmButtonText: "确定",
                showCancelButton: false,
                showClose: false,
                dangerouslyUseHTMLString: false,
                center: true,
              })
                .then(() => {
                  this.cancalCloseVideo();
                  this.closeWindow();
                })
                .catch(() => {
                  this.cancalCloseVideo();
                  this.closeWindow();
                });
            } else {
              this.$alert("", "考试完成！", {
                confirmButtonText: "确定",
                center: true,
                callback: () => {
                  this.cancalCloseVideo();
                  this.closeWindow();
                },
              });
            }
          } else {
            // 如果获取失败，直接显示完成提示并退出
            console.error('重新加载考试状态失败:', res.message || res.debug);
            this.$alert("", "考试完成！", {
              confirmButtonText: "确定",
              center: true,
              callback: () => {
                this.cancalCloseVideo();
                this.closeWindow();
              },
            });
          }
        })
        .catch((error) => {
          console.error('重新加载考试状态失败:', error);
          // 即使出错也显示完成提示并退出
          this.$alert("", "考试完成！", {
            confirmButtonText: "确定",
            center: true,
            callback: () => {
              this.cancalCloseVideo();
              this.closeWindow();
            },
          });
        });
      
    },
    
    // 问卷返回处理（不允许返回，但提供方法以防需要）
    handleQuestionnaireGoBack() {
      // 问卷阶段不允许返回，提示用户
      this.$message.warning('请先完成问卷，完成后即可查看考试结果');
    },
  },

  mounted() {
    // 强制清理状态，防止多用户同机考试状态残留
    this.examination = null;
    this.isDone = false;
    this.submitIng = false;
    this.stopCountdown();
    this.stopHeartbeat();
    if (this.uploadTimer) {
      clearInterval(this.uploadTimer);
      this.uploadTimer = null;
    }
    this.setupNetworkListener();

    this.$nextTick(() => {
      // setInterval(this.checkHeart, 30000);
    });
    this.$storage.setStorage([{ key: "examination", value: 1 }]);
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const query = this.$route.query || null;
    if (!query) {
      this.$router.push({
        path: "/examination",
      });
    }
    this.status = 2;
    this.itemData = query;
    this.dialogVisible = true;
    if (query.needCam && query.needCam != "false") {
      this.loginForm = {
        userId: userInfo.id,
        roomId: query.examinationId,
      };
    } else {
      this.loginForm = null;
    }
    const that = this;
    window.onbeforeunload = function () {
      return "您确定本页的操作完成了吗？页面将关闭或刷新。";
    };
    window.onunload = function () {
      that.$storage.setStorage([
        {
          key: "examination",
          value: 0,
        },
      ]);
    };
  },
  beforeUnmount() {
    console.log("examinationDetails组件即将卸载，清理所有资源");
    
    // 1. 清理所有定时器
    if (this.uploadTimer) {
      clearInterval(this.uploadTimer);
      this.uploadTimer = null;
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
    if (_timer) {
      clearInterval(_timer);
      _timer = null;
    }
    
    // 2. 停止心跳和倒计时（确保清理）
    this.stopHeartbeat();
    this.stopCountdown();
    
    // 3. 移除网络监听器
    window.removeEventListener("online", this.handleNetworkOnline);
    window.removeEventListener("offline", this.handleNetworkOffline);
    
    // 4. 清理媒体流
    this.cancalCloseVideo();
    
    // 5. 关闭所有监考员连接
    if (this.activeCalls) {
      this.activeCalls.forEach(({ conn, call }, id) => {
        console.log(`清理监考员连接: ${id}`);
        try {
          if (call) call.close();
          if (conn) conn.close();
        } catch (e) {
          console.error(`清理监考员连接[${id}]失败:`, e);
        }
      });
      this.activeCalls.clear();
    }
    
    // 6. 清理PeerID（向后端报告下线）
    if (this.examination && this.examination.id) {
      this.$https.post(`/api/my/exam/${this.examination.id}/peer`, {
        peerConnectionId: null
      }).catch(() => {
        console.log("清理PeerID失败");
      });
    }
    
    // 7. 销毁Peer实例
    if (this.peers) {
      try {
        console.log("销毁Peer连接");
        this.peers.destroy();
        this.peers = null;
      } catch (e) {
        console.error('销毁Peer实例失败:', e);
      }
    }
    
    // 8. 重置状态标志
    this.isDone = true;
    this.isInit = false;
    
    console.log("资源清理完成");
  }
};
</script>

<style lang="less" scope>
.examination-deatils {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #edf0f5;
  .video-views {
    height: 250px;
    position: absolute;
    top: 50px;
    width: 100%;
    overflow: hidden;
    .video-sroll {
      padding: 0 20px;
      background-color: #fff;
      border-radius: 5px;
    }
    .video-border {
      border: 1px solid #ddd;
    }
    .video-box {
      width: 49%;
      margin-right: 1%;
      float: left;
      text-align: center;
      background-color: #928f9a;
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
    }
    .video-view {
      flex: 1;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .videoSelectTypes {
      position: absolute;
      top: 10px;
      left: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 7px;
      z-index: 10;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
    }
    .device-select {
      min-width: 180px;
      margin-left: 6px;
    }
    .videoSelectType {
      margin: 3px 5px;
      padding: 5px 8px;
      // white-space: normal;
      background-color: #fff;
      color: #000;
      cursor: pointer;
      border-radius: 2px;
    }
    .videx-box-width {
      width: 300px;
      display: block;
      background: transparent;
    }
    .viedo-tips {
      width: 50%;
      float: left;
      padding: 10px;
      text-align: left;
      line-height: 30px;
      background-color: #eef0f4;
      height: 400px;
      overflow: auto;
    }
  }
  .adjustment {
    top: 20%;
    padding: 0 20%;
    height: auto;
  }
  .content {
    position: absolute;
    height: 100%;
    width: 100%;
    .tips-card {
      position: absolute;
      right: 50px;
      top: 50px;
      background-color: #fff;
      text-align: center;
      line-height: 2;
      padding: 20px 40px;
      color: #5e6482;
      overflow: initial;
      font-size: 14px;
      .el-divider--horizontal {
        margin: 10px 0;
      }
      .timing {
        color: tomato;
      }
      .submit {
        position: absolute;
        bottom: -60px;
        width: 100%;
        left: 0;
      }
    }
    .box-card {
      position: relative;
      color: #5e6482;
      width: 60%;
      margin: 10% 20%;
      .el-card__header {
        font-size: 16px;
        font-weight: bold;
      }
      .card {
        font-size: 14px;
        padding: 20px;
        line-height: 30px;
        .el-radio,
        .el-checkbox {
          width: 100%;
          padding: 8px 10px;
          font-size: 14px;
          margin-right: 0;
          margin-bottom: 8px;
          height: auto;
          display: flex !important;
          align-items: center !important;
          border-bottom: 1px solid #f0f0f0;
        }
        .el-radio__input,
        .el-checkbox__input {
          flex-shrink: 0;
        }
        .el-radio__label,
        .el-checkbox__label {
          white-space: normal !important;
          word-wrap: break-word;
          word-break: break-word;
          line-height: 1.6 !important;
          flex: 1;
        }
        .question-progress {
          font-size: 14px;
          color: #999;
          margin-bottom: 12px;
        }
      }
      .next {
        padding: 0 20px;
        float: right;
        margin: 0 20px 20px 0;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
          pointer-events: none;
        }
      }
    }
  }
}

.loading {
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  line-height: 50px;
}
.tips {
  padding: 10px 20px;
  line-height: 2;
  font-size: 13px;
  .title {
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }
  .time {
    text-align: center;
  }
  .description {
    text-align: center;
    margin-bottom: 10px;
  }
  .rule {
    border: 1px solid #e4e7ed;
    padding: 10px;
    border-radius: 5px;
    height: 300px;
    overflow: auto;
  }
  .confirms {
    padding-top: 20px;
    text-align: center;
  }
}

.btn {
  display: inline-block;
  padding: 0 20px;
  margin: 10px;
  height: 30px;
  line-height: 30px;
}

.submit-tips {
  text-align: center;
  line-height: 3;
  font-size: 14px;
}
.submit-loading {
  text-align: center;
  line-height: 3;
  font-size: 14px;
}

.el-dialog__header {
  display: none;
}

/* ✅ 优化：标题栏样式 */
.exam-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  
  .header-back-btn {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    color: #409eff;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s;
    
    &:hover {
      background: #ecf5ff;
      color: #66b1ff;
    }
    
    i {
      margin-right: 4px;
      font-size: 16px;
    }
    
    span {
      font-size: 14px;
    }
  }
  
  .header-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #303133;
    
    &.questionnaire-title {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      
      .title-label {
        color: #409eff;
        font-weight: 600;
      }
      
      .title-separator {
        color: #909399;
        margin: 0 4px;
      }
      
      .title-text {
        color: #606266;
      }
    }
    
    .title-text {
      max-width: 600px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.device-select-bar {
   display: flex;
   align-items: center;
   gap: 8px;
   padding: 8px 12px;
   margin: 12px 0 0 0;
   width: 49%;
   float: left;
   background: #fff;
   border: 1px solid #e5e7eb;
   border-radius: 4px;
   flex-wrap: nowrap;
 }
 .device-select-bar > div {
   white-space: nowrap;
 }
 .device-select {
   width: 160px;
 }
</style>
